<template>
  <div>
    <wc-section-title title='Staging'></wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'staging-base',
  computed: {
    menu () {
      return [
        {
          title: 'Dashboard',
          icon: 'mdi-view-column-outline',
          route: { name: 'StagingDashboard' }
        },
        {
          title: 'Lawn',
          icon: 'mdi-grass',
          route: {
              name: 'StagingLawn'
          }
        },
        {
          title: 'Snow',
          icon: 'mdi-snowflake',
          route: {
              name: 'StagingSnow'
          }
        },
        {
          title: 'Startup',
          icon: 'mdi-water',
          route: {
              name: 'StagingStartup'
          }
        },
        {
          title: 'Blowdown',
          icon: 'mdi-water',
          route: {
              name: 'StagingBlowdown'
          }
        }
      ]

    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Staging Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  }
}
</script>
